import React, { Component } from 'react';
import AppBar from '@material-ui/core/AppBar';
import red from '@material-ui/core/colors/red';
import { NavigationLink } from '../components';
import { ThemeImages, ThemeColors } from '../theme';

class ActivationFailed extends Component {

  render() {
    const containerStyle = {
      width: '300px',
      margin: '0 auto',
      marginTop: 'calc(50vh - 215px)',
      boxShadow: '0px 0px 5px 0px rgba(0,0,0,0.75)',
    };
    const formGroupStyle = {
      width: '100%',
      textAlign: 'center',
    };
    return (

      <div style={containerStyle}>
        <div style={{ padding: 20 }}>
          <img src={ThemeImages.logoPath} alt="Logo" style={{ width: '100%' }} />
        </div>
        <AppBar title="Aktivierung fehlgeschlagen" titleStyle={{ color: ThemeColors.darkTextOnPrimaryBackground ? 'black' : 'white', fontSize: 14 }} showMenuIconButton={false} style={{ textAlign: 'center' }} />

        <div
          style={{
            ...formGroupStyle,
            marginTop: 20,
            paddingBottom: 10,
            color: red[500],
          }}
        >
          <p> Leider ist bei der Aktivierung ein Fehler aufgetreten. Möglicherweise ist der Aktivierungslink abgelaufen. Wir haben einen neuen Link an die hinterlegte E-Mail Adresse gesendet.</p>

          <NavigationLink to="login">Hier anmelden</NavigationLink>
          <br />
          <NavigationLink to="signup">Zur Registrierung</NavigationLink>
        </div>
      </div>
    );
  }
}


export default ActivationFailed;



// WEBPACK FOOTER //
// ./src/app/activateaccount/activationfailed.js